<template>
  <div class="foo-bar">
    <div style="width: 100%; display: flex; flex-direction: column">
      <div id="optional-header" v-if="optionalHeaderText !== ''">
        <div>{{ optionalHeaderText }}</div>
      </div>

      <div
        id="foo-data"
        :style="
          first
            ? 'border-radius: 8px 0 0 0'
            : last
            ? 'border-radius: 0 0 0 8px'
            : ''
        "
      >
        <!-- each pair is a single flex row so label and value align vertically -->
        <div v-for="(pair, index) in pairs" :key="index" class="row-pair">
          <div class="row-label" v-html="pair.label"></div>
          <div class="row-value" v-html="pair.value"></div>
        </div>

        <!-- user feedback alert (same as original RowItem) -->
        <SuccessfulSaveAlert v-if="showUserfeedback" />
      </div>
    </div>

    <!-- Edit button -->
    <div
      id="action"
      :style="
        first
          ? 'border-radius: 0 8px 0 0'
          : last
          ? 'border-radius: 0 0 8px 0'
          : ''
      "
    >
      <v-btn icon @click="$emit('edit', $event)" v-if="editable">
        <v-icon v-if="notEditable" :color="this.color">mdi-eye</v-icon>
        <edit-icon v-else />
      </v-btn>
    </div>
  </div>
</template>

<script>
import EditIcon from '../../icons/EditIcon';
import SuccessfulSaveAlert from '../feed-in-system-details/SuccessfulSaveAlert.vue';
import { emptyEventData } from '../../store/feedInSystemsModule';

export default {
  name: 'RowItemAligned',
  components: {
    EditIcon,
    SuccessfulSaveAlert,
  },
  props: {
    optionalHeaderText: { type: String, default: '', required: false },
    labels: { type: Array, default: () => [] }, // array of HTML/strings for the left column
    values: { type: Array, default: () => [] }, // array of HTML/strings for the right column
    editable: { type: Boolean, default: true },
    field: { type: String, default: '' },
    first: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
    notEditable: { type: Boolean, default: false },
    color: { type: String },
  },
  computed: {
    notifyEvent() {
      return this.$store.getters.getNotifyEvent ?? emptyEventData;
    },
    showUserfeedback() {
      return this.notifyEvent.field === this.field && this.field !== '';
    },
    pairs() {
      const L = Array.isArray(this.labels) ? this.labels : [];
      const V = Array.isArray(this.values) ? this.values : [];
      const max = Math.max(L.length, V.length);
      const out = [];
      for (let i = 0; i < max; i++) {
        out.push({ label: L[i] ?? '', value: V[i] ?? '' });
      }
      return out;
    },
  },
  methods: {
    hideConfirmationMessage() {
      setTimeout(() => {
        this.$store.commit('setNotifyEvent', emptyEventData);
      }, 3000);
    },
  },
  watch: {
    notifyEvent(event) {
      if (event.field) {
        this.hideConfirmationMessage();
      }
    },
  },
};
</script>

<style scoped>
#foo-data {
  background-color: rgba(255, 255, 255, 0.9);
  display: block;
  width: 100%;
  padding: 18px 0 18px 25px;
  margin-right: 1px;
}

#optional-header {
  color: #6e6e6e;
  padding: 18px 0 0 25px;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  width: 100%;
  margin-right: 1px;
}

/* each label/value pair is one row — label left, value right */
.row-pair {
  display: flex;
  padding: 12px 0;
  min-height: 22px;
  border-top: none;
}

.row-label {
  width: 30%;
  font-size: 16px;
  color: #6e6e6e;
  opacity: 1;
  /* smaller text, lighter weight like the design */
}

.row-value {
  width: 70%;
  font-size: 18px;
  line-height: 22px;
  color: #6e6e6e;
  opacity: 1;
}

#action {
  min-height: 100%;
  width: 6%;
  min-width: 48px;
  justify-content: center;
  align-items: center;
  display: flex;
  filter: brightness(1.1);
  background-color: rgba(255, 255, 255, 0.6);
}

.foo-bar {
  display: flex;
  width: 100%;
  min-height: 48px;
}
</style>
